module.exports = __webpack_public_path__ + "assets/img/customerService-5f1884de.png";